import React from "react";
import { COLORS, RADIUS } from "../../theme";

const TILE = 256;
const GRADE = 3; // 3x3 tiles ao redor do ponto — dá contexto de rua sem pedir zoom.

// Fórmulas padrão de "slippy map" (Web Mercator) — convertem lat/long pro
// sistema de tiles usado por qualquer servidor compatível com OpenStreetMap.
function latLonParaTile(lat, lon, zoom) {
  const n = 2 ** zoom;
  const x = ((lon + 180) / 360) * n;
  const latRad = (lat * Math.PI) / 180;
  const y = ((1 - Math.log(Math.tan(latRad) + 1 / Math.cos(latRad)) / Math.PI) / 2) * n;
  return { x, y };
}

// Mapa estático montado com tiles crus do OpenStreetMap (<img> puro, sem
// iframe/mapa interativo) — pensado especificamente pro comprovante, que
// precisa imprimir/virar PDF de forma confiável (iframe de mapa interativo
// não imprime de forma consistente entre navegadores). Zero chave de API,
// zero custo — só o servidor público de tiles do OSM, uso leve (só quando
// alguém abre um comprovante específico, não em toda tela).
export default function MapaLocalizacao({ latitude, longitude, zoom = 17, tamanho = 320 }) {
  if (latitude == null || longitude == null) return null;

  const { x, y } = latLonParaTile(latitude, longitude, zoom);
  const centroX = Math.floor(x);
  const centroY = Math.floor(y);
  const topoX = centroX - 1;
  const topoY = centroY - 1;

  const marcadorX = (x - topoX) * TILE;
  const marcadorY = (y - topoY) * TILE;

  const tiles = [];
  for (let dy = 0; dy < GRADE; dy++) {
    for (let dx = 0; dx < GRADE; dx++) {
      tiles.push({ tx: topoX + dx, ty: topoY + dy, col: dx, row: dy });
    }
  }

  const ladoTotal = TILE * GRADE;
  const linkMaps = `https://www.google.com/maps?q=${latitude},${longitude}`;

  return (
    <div>
      <div
        style={{
          position: "relative",
          width: tamanho,
          height: tamanho,
          maxWidth: "100%",
          margin: "0 auto",
          overflow: "hidden",
          borderRadius: RADIUS.md,
          border: `1px solid ${COLORS.border}`,
          background: COLORS.gray,
        }}
      >
        <div style={{ position: "absolute", top: 0, left: 0, width: ladoTotal, height: ladoTotal, transform: `scale(${tamanho / ladoTotal})`, transformOrigin: "top left" }}>
          {tiles.map((t) => (
            <img
              key={`${t.tx}-${t.ty}`}
              src={`https://tile.openstreetmap.org/${zoom}/${t.tx}/${t.ty}.png`}
              alt=""
              width={TILE}
              height={TILE}
              style={{ position: "absolute", left: t.col * TILE, top: t.row * TILE, display: "block" }}
            />
          ))}
          <div
            style={{ position: "absolute", left: marcadorX, top: marcadorY, transform: "translate(-50%, -100%)" }}
            aria-label="Local da batida"
          >
            <svg width="30" height="40" viewBox="0 0 30 40" style={{ filter: "drop-shadow(0 2px 3px rgba(0,0,0,0.4))" }}>
              <path d="M15 0C6.7 0 0 6.7 0 15c0 10.5 15 25 15 25s15-14.5 15-25C30 6.7 23.3 0 15 0z" fill={COLORS.danger} />
              <circle cx="15" cy="15" r="6" fill="#fff" />
            </svg>
          </div>
        </div>
      </div>
      <p style={{ fontSize: 10.5, color: COLORS.textLight, textAlign: "center", margin: "6px 0 0" }}>
        Mapa: © colaboradores do{" "}
        <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noreferrer" style={{ color: "inherit" }}>
          OpenStreetMap
        </a>
        {" · "}
        <a href={linkMaps} target="_blank" rel="noreferrer" style={{ color: COLORS.primary, fontWeight: 600 }}>
          Abrir no mapa
        </a>
      </p>
    </div>
  );
}
